import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    availableSymbols:[],
    isNotesActive: false,
    scheduleData:[]
}

const scheduleSlice = createSlice({
  name: 'SCHEDULESLICE',
  initialState,
  reducers: {
    addSymbols(state, action){
        state.availableSymbols = action.payload
    },
    notesState (state, action) {
      state.isNotesActive = !!action?.payload ? action.payload : !state.isNotesActive
    },
    addScheduleData(state, action){
      state.scheduleData = action.payload
    },
    updateScheduleData(state, action){
      
      state.scheduleData[action.payload.key].value = state.scheduleData[action.payload.key].value.map((item, index)=> {
        if(item.title.trim() === action.payload.scheduleTitle.trim()){
          return {
            ...item,
            note:action.payload
          }
        }else{
          return item;
        }
      })
    }
  },
})

// Action creators are generated for each case reducer function
export const { addSymbols, notesState, addScheduleData, updateScheduleData } = scheduleSlice.actions

export default scheduleSlice;